import { render, staticRenderFns } from "./HistoricoDeVendas.vue?vue&type=template&id=dda91f24&scoped=true"
import script from "./HistoricoDeVendas.vue?vue&type=script&lang=js"
export * from "./HistoricoDeVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda91f24",
  null
  
)

export default component.exports